import { stringifyKey } from "../decorators/StoreIdHelper";
import AcceleratorDoc, {
  AcceleratorDocStoreKey,
} from "../models/AcceleratorDoc";
import { BatchClassConfig } from "../models/config/BatchClassConfig";
import { Hydratable } from "../models/hydration/Hydratable";
import { HydratableFactory } from "../models/hydration/HydratableFactory";
import { AcceleratorDocStore } from "../stores/impl/AcceleratorDocStore";
import { AcceleratorBatchDocumentLoader } from "./AcceleratorBatchDocumentLoader";

export { AcceleratorDocHydrator };

class AcceleratorDocHydrator {
  hydratedDocs: Map<
    string,
    Hydratable<AcceleratorDoc, AcceleratorDocStoreKey>
  > = new Map();

  /**
   *
   * @param accDocKey AcceleratorDoc to remove from the cached hydration store.
   * @returns probably returns true if hydratable was cached.
   */
  delete(accDocKey: AcceleratorDocStoreKey): boolean {
    const deleted = this.hydratedDocs.delete(stringifyKey(accDocKey));
    console.log(`Deleted=${deleted} ${stringifyKey(accDocKey)}`);
    return deleted;
  }
  /**
   * Calls the AcceleratorDoc load methods thorugh the AcceleratorBatchDocumentLoader. caches returned Hydratable for
   * subsequent calls.
   *
   * TODO: remove batchInstanceUuid from here and AcceleratorBatchDocumentLoader
   */
  load(
    accDocKey: AcceleratorDocStoreKey,
    batchInstanceUuid: string,
    bcc: BatchClassConfig,
  ): Hydratable<AcceleratorDoc, AcceleratorDocStoreKey> {
    const strKey = stringifyKey(accDocKey);
    if (this.hydratedDocs.has(strKey)) return this.hydratedDocs.get(strKey)!;
    let doc;
    if (AcceleratorDocStore.getWithoutLookup(accDocKey) == undefined) {
      // acceleratorDoc not loaded yet, get Hydratable from batch loader
      doc = AcceleratorBatchDocumentLoader.loadDoc(
        accDocKey,
        batchInstanceUuid,
        bcc!,
      );
    } else {
      doc = HydratableFactory.getAcceleratorDoc(
        async () => AcceleratorDocStore.getWithoutLookup(accDocKey),
        accDocKey,
      );
    }
    // recycle the Hydratable instance.
    this.hydratedDocs.set(strKey, doc);
    return doc;
  }
}
